import React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {HorizontalSeparator} from 'src/components/lib/horizontal-separator/horizontal-separator';
import {LabelValue} from 'src/components/automation/common/module-addon-common';
import {Link} from 'src/rerouter';

import {Card} from '@spaced-out/ui-design-system/lib/components/Card';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';

import css from './scheduler-addon.css';


interface EditAddonProps {
  onSelect: (step: 'selector' | 'component') => void;
  schedulerId: string;
  schedulerType: string;
}

export const EditAddon = ({
  onSelect,
  schedulerId,
  schedulerType,
}: EditAddonProps) => {
  const {t} = useLabelTranslation();

  const schedulerName = 'Test Scheduler';
  return (
    <Card
      paddingTop="medium"
      paddingBottom="medium"
      paddingLeft="small"
      paddingRight="small"
      classNames={{wrapper: css.detailsCard}}
    >
      <div className={css.detailsItems}>
        <LabelValue
          label={t('Selected_Template', 'Selected Template')}
          value={schedulerName}
        />
        <div>
          <Link to={`/automation-survey/${schedulerId}`} target="_blank">
            <Button type="ghost">{t('Preview', 'Preview')}</Button>
          </Link>
          <Button
            type="secondary"
            iconRightName="chevron-right"
            onClick={() => onSelect('selector')}
          >
            {t('Edit', 'Edit')}
          </Button>
        </div>
      </div>
      <HorizontalSeparator />
      <div className={css.detailsItems}>
        <LabelValue
          label={t('Display_As', 'Display As')}
          value={
            schedulerType === 'text'
              ? t('Text_Component', 'Text Component')
              : t('Button', 'Button')
          }
        />
        <Button
          type="secondary"
          iconRightName="chevron-right"
          onClick={() => onSelect('component')}
        >
          {t('Edit', 'Edit')}
        </Button>
      </div>
    </Card>
  );
};
